import { getApiActionTypes } from '../../shared/store/storeHelpers';

export const fetchEntityFilingDecisionsTypes = getApiActionTypes(
  'FILING_DECISIONS_V2/FETCH_ENTITY_FILING_DECISIONS',
);

export const fetchFilingDecisionsAmountDetailsTypes = getApiActionTypes(
  'FILING_DECISIONS_V2/FETCH_FILING_DECISIONS_AMOUNT_DETAILS',
);
